import React from 'react'
import notFoundImage from '../assets/images/not-found/404.svg'

export default function NotFound () {
  return (
    <div className='px-5 py-5 row'>
      <div className='col-12 pb-5'>
        <div className='row'>
          <h1 className='web-header pb-5 text-center'>Page Not Found</h1>
          <div className='text-regular text-center post'>
            <img src={notFoundImage} alt='Not Found' style={{ maxWidth: '500px', display: 'block', margin: '0 auto' }} />
            <br />
            <br />
            The page you are looking for could not be found.
          </div>
        </div>
      </div>
    </div>
  )
}